import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname, search, key } = useLocation();

  useEffect(() => {
    // Use instant scroll behavior for immediate effect
    // key changes on every navigation (even same path), pathname+search covers all cases
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, search, key]);

  return null;
};
